import { mutateApi, queryApi } from "src/utils/api/ApiMethods"
import { getCurrentMarinaSlug } from "src/utils/url/parsing/marina"

export const createDromoImport = ({ dromoId, importType, numRows }) => {
  const marinaSlug = getCurrentMarinaSlug()

  return mutateApi({
    url: `/manage/${marinaSlug}/dromo_imports`,
    method: "POST",
    data: {
      dromo_id: dromoId,
      import_type: importType,
      num_rows: numRows,
    },
  })
}

export const getDromoImports = ({ page = 1 } = {}) => {
  const marinaSlug = getCurrentMarinaSlug()

  return queryApi(`/manage/${marinaSlug}/dromo_imports.json?page=${page}`)
}

export const getDromoImportRows = ({ dromoImportId, page = 1, statuses }) => {
  const marinaSlug = getCurrentMarinaSlug()
  const params = new URLSearchParams({ page })
  if (statuses?.length) {
    statuses.forEach((s) => params.append("statuses[]", s))
  }

  return queryApi(
    `/manage/${marinaSlug}/dromo_imports/${dromoImportId}/rows.json?${params}`
  )
}

export const getContractsConfig = () => {
  const marinaSlug = getCurrentMarinaSlug()

  return queryApi(`/manage/${marinaSlug}/dromo_imports/context/contracts.json`)
}

export const getCustomersConfig = () => {
  const marinaSlug = getCurrentMarinaSlug()

  return queryApi(`/manage/${marinaSlug}/dromo_imports/context/customers.json`)
}

export const getGeneralLedgerCodesConfig = () => {
  const marinaSlug = getCurrentMarinaSlug()

  return queryApi(
    `/manage/${marinaSlug}/dromo_imports/context/general_ledger_codes.json`
  )
}

export const getInventoryQuantityAdjustmentConfig = () => {
  const marinaSlug = getCurrentMarinaSlug()

  return queryApi(
    `/manage/${marinaSlug}/dromo_imports/context/inventory_quantity_adjustment.json`
  )
}

export const getItemsConfig = () => {
  const marinaSlug = getCurrentMarinaSlug()

  return queryApi(`/manage/${marinaSlug}/dromo_imports/context/items.json`)
}

export const getMetersConfig = () => {
  const marinaSlug = getCurrentMarinaSlug()

  return queryApi(`/manage/${marinaSlug}/dromo_imports/context/meters.json`)
}

export const getLongTermWaitlistConfig = () => {
  const marinaSlug = getCurrentMarinaSlug()

  return queryApi(
    `/manage/${marinaSlug}/dromo_imports/context/long_term_waitlist.json`
  )
}

export const getReservationsConfig = () => {
  const marinaSlug = getCurrentMarinaSlug()

  return queryApi(
    `/manage/${marinaSlug}/dromo_imports/context/reservations.json`
  )
}

export const getSpacesConfig = () => {
  const marinaSlug = getCurrentMarinaSlug()

  return queryApi(`/manage/${marinaSlug}/dromo_imports/context/spaces.json`)
}

export const getImportConfig = (importType) => {
  switch (importType) {
    case "contracts":
      return getContractsConfig()
    case "customers":
      return getCustomersConfig()
    case "general_ledger_codes":
      return getGeneralLedgerCodesConfig()
    case "inventory_quantity_adjustment":
      return getInventoryQuantityAdjustmentConfig()
    case "items":
      return getItemsConfig()
    case "long_term_waitlist":
      return getLongTermWaitlistConfig()
    case "meters":
      return getMetersConfig()
    case "reservations":
      return getReservationsConfig()
    case "spaces":
      return getSpacesConfig()
    default:
      throw new Error(`Unknown import type: ${importType}`)
  }
}
